import {setHash} from "@/utils/utils"

export default {
	setBodyOverflowHidden: (state, bool) => {
		state.bodyOverflowHidden = bool;
	},

	setDatepickerOpen: (state, str) => {
		state.datepickerOpen = str;
	},
	setParticipantsDropdownOpen: (state, bool) => {
		if (!window.participantsDropdownDisabled) {
			state.participantsDropdownOpen = bool;
		}
	},
	setPackagesMobileDropdownOpen: (state, bool) => {
		state.packagesMobileDropdownOpen = bool;
	},

	setProductUnavailable: (state, bool) => {
		state.productUnavailable = bool;
	},

	setParticipants: (state, newArray) => {
		state.participants = newArray;
	},
	setPackage: (state, newPackCode) => {
		state.packCode = newPackCode;
	},
	setPackageId: (state, pacakgeId) => {
		state.packageId = pacakgeId;
	},

	setLoading: (state, bool) => {
		state.loading = bool;
	},

	setErrorMessageOpen: (state, str) => {
		state.errorMessageOpen = str;
	},

	setScrollToPrestationFired: (state, bool) => {
		state.scrollToPrestationFired = bool;
	},

	setCheckedNeedToPreselectPrestations: (state, bool) => {
		state.checkedNeedToPreselectPrestations = bool;
	},

	setQuoteRequestsFinishedLoading: (state, bool) => {
		state.quoteRequestsFinishedLoading = bool;
	},

	setLastQuotesRequestTimestamp: (state, timestamp) => {
		state.lastQuotesRequestTimestamp = timestamp;
	},

	setScreenType: (state, newType) => {
		state.screenType = newType;
	},

	setSeason: (state, newSeason) => {
		state.season = newSeason;
	},
	setTransport: (state, newBool) => {
		state.transportCheckbox = newBool;
	},
	setTransportTrue: (state, newBool) => {
		state.transportCheckbox = newBool;
	},

	setActivePrestations(state, activePrestations) {
        state.activePrestations = activePrestations;
    },

	setPrestationsFromCatalog(state, prestationsFromCatalog) {
        state.prestationsFromCatalog = prestationsFromCatalog;
    },

	setFeeFromWIYP(state, newWiypFee) {
		state.wiypFees = newWiypFee;
	},

	setFlightOrigins(state, flightOrigins) {
		state.flightOrigins = flightOrigins
	},

	setFlightOrigin(state, origin) {
		console.log('[setFlightOrigin]: origin', origin);
		
		state.flightOrigin = origin
		setHash({origin})
	},

	setTransportationSelected(state, selected) {
		state.transportationSelected = selected
	},
	updateInitialPrestationsInState(state, newInitialPrestationsArray) {
		state.initialPrestationsArray = newInitialPrestationsArray;
	},
};
